module.exports = __webpack_public_path__ + "img/18_52.e0e5cf48.png";